4<template>
  <b-modal
    v-model="modal"
    :title="title"
    size="lg"
    :no-enforce-focus="false"
    :no-close-on-backdrop="true"
  >
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <b-card-body>
          <form autocomplete="off">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Nome da categoria *</label>
                  <input
                    id="name"
                    v-model="categorie.name"
                    name="name"
                    placeholder="Ex: Basic, Deluxe, etc"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.categorie.name.$error
                    }"
                  />
                  <div
                    v-if="submitted && !$v.categorie.name.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="audience">Público</label>
                  <select id="audience" v-model="categorie.audience" class="form-control">
                    <option value="guest">Convidados</option>
                    <option value="internal">Interno (diretoria, staff, produtora, fornecedores)</option>
                  </select>
                  <small class="form-text text-muted">
                    O relatório "RL Previsível" conta apenas os apartamentos do bloco de
                    convidados. O bloco interno fica de fora — é a sobra reservada para a equipe.
                  </small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="description">Descrição *</label>
                  <textarea
                    id="description"
                    v-model="categorie.description"
                    name="description"
                    placeholder="Ex: Banheiro maior, banheira, etc"
                    class="form-control"
                    rows="3"
                    :class="{
                      'is-invalid': submitted && $v.categorie.description.$error
                    }"
                  >
                  </textarea>
                  <div
                    v-if="submitted && !$v.categorie.description.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
            </div>
          </form>
        </b-card-body>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" :disabled="user.role !== 'Admin'" @click="saveCategorie()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  props: {
    idHotel: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Adicionar Nova Categoria',
      loading: true,
      fullPage: true,
      submitted: false,
      // audience default 'guest' — mesmo default da coluna no banco
      categorie: { audience: 'guest' },
      modal: false,
      modalForm: false
    }
  },
  validations: {
    categorie: {
      name: { required },
      description: { required }
    }
  },
  mounted () {
    console.log(this.idHotel)
  },
  methods: {
    ...mapActions('hotelCategory', {
      getCategory: 'getCategory',
      postData: 'save'
    }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Categoria'
        this.getCategory(id).then((data) => {
          this.categorie = this.data
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async saveCategorie () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      this.categorie.hotel_id = this.idHotel
      await this.postData(this.categorie).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.categorie = { audience: 'guest' }
      this.$v.$reset()
      this.$emit('created')
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('event', ['setting']),
    ...mapState('hotelCategory', { data: 'category' })
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.modal-header {
  background: #000 !important;
  color: #fff;
}
.border-gray {
  border: 1px solid #e9e9e9;
}
</style>
